const sortedStores = ({ storesData = [], stickyStore }) => {
  if (!storesData.length || !stickyStore) return storesData;

  const selectedStoreId = stickyStore.id;

  // Check if the selected store exists in the stores data
  const selectedStoreHasStock = storesData.some(
    (store) => store.id === selectedStoreId
  );

  if (!selectedStoreHasStock) return storesData;

  // Filter out the selected store and move it to the top
  return [
    stickyStore,
    ...storesData.filter((store) => store.id !== selectedStoreId),
  ];
};

export default sortedStores;
